import { render, staticRenderFns } from "./ChannelConfig.vue?vue&type=template&id=2a301b78&scoped=true"
import script from "./ChannelConfig.vue?vue&type=script&lang=js"
export * from "./ChannelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a301b78",
  null
  
)

export default component.exports